"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSafeTransactionRequest = exports.aggregateTransaction = void 0;
const tslib_1 = require("tslib");
const types_1 = require("../types");
const utils_1 = require("./utils");
const ethers_1 = require("ethers");
const utils_2 = require("ethers/lib/utils");
const safe_1 = require("../encode/safe");
const utils_3 = require("../encode/utils");
function createSafeSignature(signer, structHash) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        return signer.signMessage(ethers_1.ethers.utils.arrayify(structHash));
    });
}
function splitSignature(sig) {
    let sigV = parseInt(sig.slice(-2), 16);
    switch (sigV) {
        case 0:
        case 1:
            sigV += 31;
            break;
        case 27:
        case 28:
            sigV += 4;
            break;
        default:
            throw new Error("Invalid signature");
    }
    sig = sig.slice(0, -2) + sigV.toString(16);
    return {
        r: ethers_1.BigNumber.from("0x" + sig.slice(2, 66)).toString(),
        s: ethers_1.BigNumber.from("0x" + sig.slice(66, 130)).toString(),
        v: ethers_1.BigNumber.from("0x" + sig.slice(130, 132)).toString(),
    };
}
function createStructHash(chainId, safe, to, value, data, operation, safeTxGas, baseGas, gasPrice, gasToken, refundReceiver, nonce) {
    const domain = {
        chainId: chainId,
        verifyingContract: safe,
    };
    const types = {
        // keccak256(
        //     "SafeTx(address to,uint256 value,bytes data,uint8 operation,uint256 safeTxGas,uint256 baseGas,uint256 gasPrice,address gasToken,address refundReceiver,uint256 nonce)"
        // );
        SafeTx: [
            { name: 'to', type: 'address' },
            { name: 'value', type: 'uint256' },
            { name: 'data', type: 'bytes' },
            { name: 'operation', type: 'uint8' },
            { name: 'safeTxGas', type: 'uint256' },
            { name: 'baseGas', type: 'uint256' },
            { name: 'gasPrice', type: 'uint256' },
            { name: 'gasToken', type: 'address' },
            { name: 'refundReceiver', type: 'address' },
            { name: 'nonce', type: 'uint256' },
        ],
    };
    const values = {
        to: to,
        value: value,
        data: data,
        operation: operation,
        safeTxGas: safeTxGas,
        baseGas: baseGas,
        gasPrice: gasPrice,
        gasToken: gasToken,
        refundReceiver: refundReceiver,
        nonce: nonce,
    };
    const structHash = utils_2._TypedDataEncoder.hash(domain, types, values);
    // console.log(`Safe Struct Hash: ${structHash}`);
    return structHash;
}
function aggregateTransaction(txns) {
    let transaction;
    if (txns.length == 1) {
        transaction = txns[0];
    }
    else {
        transaction = safe_1.createSafeMultisendTransaction(txns);
    }
    return transaction;
}
exports.aggregateTransaction = aggregateTransaction;
function buildSafeTransactionRequest(signer, args) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const transaction = aggregateTransaction(args.transactions);
        const safeTxnGas = "0";
        const baseGas = "0";
        const gasPrice = "0";
        const gasToken = ethers_1.ethers.constants.AddressZero;
        const refundReceiver = ethers_1.ethers.constants.AddressZero;
        const safeAddress = utils_1.deriveSafe(args.from);
        // Generate the struct hash
        // NOTE: this includes a client side optimization over the current relayers
        // Generates struct hash locally instead of going across the network using the RPC call
        const structHash = createStructHash(args.chainId, safeAddress, transaction.to, transaction.value, transaction.data, transaction.operation, safeTxnGas, baseGas, gasPrice, gasToken, refundReceiver, args.nonce);
        const sig = yield createSafeSignature(signer, structHash);
        // Split the sig then pack it into Gnosis accepted rsv format
        const splitSig = splitSignature(sig);
        const packedSig = utils_3.abiEncodePacked({ type: "uint256", value: splitSig.r }, { type: "uint256", value: splitSig.s }, { type: "uint8", value: splitSig.v });
        const sigParams = {
            gasPrice,
            operation: `${transaction.operation}`,
            safeTxnGas,
            baseGas,
            gasToken,
            refundReceiver,
        };
        const req = {
            from: args.from,
            to: transaction.to,
            proxyWallet: safeAddress,
            data: transaction.data,
            nonce: args.nonce,
            signature: packedSig,
            signatureParams: sigParams,
            type: types_1.TransactionType.SAFE,
        };
        console.log(`Created Safe Transaction Request: `);
        console.log(req);
        return req;
    });
}
exports.buildSafeTransactionRequest = buildSafeTransactionRequest;
